import React, { useEffect } from 'react';
import { FiX, FiCalendar, FiUser, FiFileText, FiHome, FiXCircle, FiCheckCircle, FiPlus, FiLogOut, FiEdit2 } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import EditBookingModal from '../../components/EditBookingModal';
import { handlePrintBill } from '../../utils/billUtils';

const BookingModals = ({ 
  showCheckinModal, 
  setShowCheckinModal, 
  showBookingInfoModal, 
  setShowBookingInfoModal, 
  selectedRoom, 
  selectedBooking, 
  setSelectedBooking,
  // Additional props needed for the modals
  floors, 
  rooms, 
  filteredRooms, 
  setFilteredRooms, 
  selectedFloor, 
  setSelectedFloor, 
  formData, 
  setFormData, 
  handleCheckin, 
  handleDirectCheckin,
  handleCancelBooking,
  resetForm, 
  addPerson, 
  removePerson, 
  updatePerson,
  handlePerformCheckin,
  handlePerformCheckout,
  fetchData,
  setViewMode
}) => {
  const [showCancelModal, setShowCancelModal] = React.useState(false);
  const [showCheckoutModal, setShowCheckoutModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [cancelFormData, setCancelFormData] = React.useState({
    remark: '',
    refundableAmount: 0
  });

  
  // Checkout form state
  const [dynamicGst, setDynamicGst] = React.useState('18');
  const [dynamicFinalAmount, setDynamicFinalAmount] = React.useState(0);
  const [dynamicPaidAmount, setDynamicPaidAmount] = React.useState(0);
  const [dynamicOtherAmount, setDynamicOtherAmount] = React.useState('');
  const [dynamicOtherAmountRemark, setDynamicOtherAmountRemark] = React.useState('');
  const [settledAmount, setSettledAmount] = React.useState(0);
  const [tipAmount, setTipAmount] = React.useState(0);
  const [discountAmount, setDiscountAmount] = React.useState(0);
  const [finalPendingAmount, setFinalPendingAmount] = React.useState(0);
  const [paymentMethod, setPaymentMethod] = React.useState('cash');
  const [customerGstNumber, setCustomerGstNumber] = React.useState('');
  const [loadingGstSettings, setLoadingGstSettings] = React.useState(false);
  
  // Calculation states (matching CheckinManagement.js)
  const [calculatedBase, setCalculatedBase] = React.useState(0);
  const [calculatedGstAmount, setCalculatedGstAmount] = React.useState(0);
  const [calculatedTotal, setCalculatedTotal] = React.useState(0);
  const [calculatedDue, setCalculatedDue] = React.useState(0);
  const [isGstInclude, setIsGstInclude] = React.useState(false);
  const [paymentAmountByApi, setPaymentAmountByApi] = React.useState({});


  React.useEffect(()=>{
    setFormData((olddata)=>{
      return {
        ...olddata,
        paymentMethod
      }
    })
  },[paymentMethod])

  useEffect(()=>{
      const isEmpty = Object.keys(paymentAmountByApi || {}).length === 0;
      if (isEmpty) return; // ✅ just stop execution
  
      let pendingAmount = paymentAmountByApi.totalRoomAmount - paymentAmountByApi.paidAmount + Number(dynamicOtherAmount);
      let diffAmount = pendingAmount - settledAmount;
  
      console.log(pendingAmount,"pendingAmount-22",diffAmount,settledAmount);
      
      if(pendingAmount > settledAmount){
        let roomBaseAmount = paymentAmountByApi.roomBaseAmount-((diffAmount*100)/(100+dynamicGst));
        roomBaseAmount =  Math.round(Number(roomBaseAmount.toFixed(2))); // 10
        let parsedGstAmount = Math.round((roomBaseAmount * dynamicGst) / 100);
        let totalAmount = roomBaseAmount + parsedGstAmount;
        let dueBalance = totalAmount - dynamicPaidAmount + Number(dynamicOtherAmount);
        let pendingAmount = roomBaseAmount + parsedGstAmount + Number(dynamicOtherAmount) + diffAmount - paymentAmountByApi.paidAmount;
        setCalculatedTotal(totalAmount);
        setCalculatedBase(roomBaseAmount);
        setCalculatedGstAmount(parsedGstAmount);
        setCalculatedDue(dueBalance);
        setDiscountAmount(diffAmount);
        setFinalPendingAmount(pendingAmount);
        setTipAmount(0);
      }else{
        let roomBaseAmount = paymentAmountByApi.roomBaseAmount;
        let totalAmount = paymentAmountByApi.totalRoomAmount;
        const dueBalance = paymentAmountByApi.totalRoomAmount - paymentAmountByApi.paidAmount + Math.abs(diffAmount) + Number(dynamicOtherAmount);
        let pendingAmount = paymentAmountByApi.totalRoomAmount + Number(dynamicOtherAmount) - paymentAmountByApi.paidAmount;
        setCalculatedTotal(totalAmount);
        setCalculatedBase(roomBaseAmount);
        setCalculatedGstAmount(paymentAmountByApi.gstAmount);
        setCalculatedDue(dueBalance);
        setDiscountAmount(0);
        setTipAmount(Math.abs(diffAmount));
        setFinalPendingAmount(pendingAmount);
      }
      
    },[settledAmount,dynamicOtherAmount,paymentAmountByApi])

  
  useEffect(()=>{
    let roomBaseAmount = paymentAmountByApi.roomBaseAmount;
    let gstAmount = (roomBaseAmount * dynamicGst) / 100;
    let totalRoomAmount = roomBaseAmount + gstAmount;
    setPaymentAmountByApi((old)=>{
      return {
        ...old,
        gstAmount,
        totalRoomAmount
      }
    })
  },[dynamicGst])

    // Initialize dynamic values when modal opens
  const initializeCheckoutModal = async (checkin) => {
    setSelectedBooking(checkin);
    setLoadingGstSettings(true);
    
    // Fetch current GST settings
    try {
      const response = await api.get('/vendor/room-management/settings');
      const currentGst = response.data.settings.gstPercentage;
      const gstInclude = response.data.settings.isGstInclude || false;
      const dueBalance = checkin.pricing.finalRoomAmount - checkin.pricing.paidAmount;
      
      setCalculatedBase(checkin.pricing.roomBaseAmount);
      setCalculatedGstAmount(checkin.pricing.gstAmount);
      setCalculatedTotal(checkin.pricing.finalRoomAmount);
      setDynamicPaidAmount(checkin.pricing.paidAmount)
      setCalculatedDue(dueBalance);
      setDynamicGst(currentGst);
      setIsGstInclude(gstInclude);
      setDynamicFinalAmount(parseFloat(checkin.pricing.initialRoomAmount.toFixed(2)));
      setFinalPendingAmount(dueBalance);
      setSettledAmount(dueBalance);
      setPaymentAmountByApi({
        gstAmount: checkin.pricing.gstAmount,
        totalRoomAmount: checkin.pricing.totalFinalAmount,//Gst Amount + RoomBase Amount
        paidAmount: checkin.pricing.paidAmount,
        roomBaseAmount: checkin.pricing.roomBaseAmount,
      })
      // Show modal after all values are set
      setShowCheckoutModal(true);
    } catch (error) {
      console.error('Error fetching GST settings:', error);
      setShowCheckoutModal(true);
    } finally {
      setLoadingGstSettings(false);
    }
  };

  // Handle checkout with calculations
  const handleCheckoutSubmit = async () => {
    if (!selectedBooking) return;

    try {
      // Use the calculated values from the calculation states
      const requestData = {
        actualCheckoutDateTime: new Date().toISOString(),
        gstPercentage: dynamicGst,
        finalAmount: dynamicFinalAmount,
        finalPendingAmount: finalPendingAmount,
        settledAmount: settledAmount,
        // paidAmount: parseFloat(dynamicPaidAmount) + parseFloat(settledAmount),
        // pendingAmount: calculatedDue > 0 ? calculatedDue : 0,
        tipAmount: parseFloat(tipAmount),
        discountAmount: parseFloat(discountAmount),
        otherAmount: parseFloat(dynamicOtherAmount),
        otherAmountRemark: dynamicOtherAmountRemark,
        isGstInlude: isGstInclude,
        gstAmount: calculatedGstAmount,
        paymentMethod: paymentMethod,
        customerGstNumber: customerGstNumber
      };

      await api.post(`/vendor/checkin-management/checkout/${selectedBooking.checkinId}`, requestData);
      
      toast.success('Guest checked out successfully!');
      setShowCheckoutModal(false);
      
      // Auto-generate bill after successful checkout
      setTimeout(() => {
        handlePrintBill(selectedBooking.checkinId);
      }, 1000);
      
      setSelectedBooking(null);
      
      // Refresh the data
      if (fetchData) {
        fetchData();
      }
    } catch (error) {
      console.error('Error during checkout:', error);
      toast.error(error.response?.data?.message || 'Failed to check out guest');
    }finally{
      setViewMode("floors")
    }
  };
  return (
    <>
      {/* New Check-in Modal (for available rooms) */}
      {showCheckinModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-5 mx-auto p-6 border w-full max-w-6xl shadow-2xl rounded-xl bg-white">
            <div className="max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200 sticky top-0 bg-white">
                <h3 className="text-xl font-bold text-gray-900">New Booking</h3>
                <button
                  onClick={() => {
                    setShowCheckinModal(false);
                    resetForm();
                  }}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <FiX className="text-xl text-gray-500" />
                </button>
              </div>

              <form onSubmit={handleCheckin}>
                {/* Basic Information Section */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <FiCalendar className="mr-2 text-blue-600" />
                    Basic Information
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Floor
                      </label>
                      <select
                        value={selectedFloor || ''}
                        onChange={(e) => {
                          const floorId = e.target.value;
                          setSelectedFloor(floorId);
                          // Filter rooms based on selected floor
                          if (floorId) {
                            const filteredRooms = rooms.filter(room => 
                              room.floorId?._id === floorId
                            );
                            setFilteredRooms(filteredRooms);
                          } else {
                            setFilteredRooms(rooms);
                          }
                          // Reset room selection when floor changes
                          setFormData({ ...formData, roomId: '' });
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">All Floors</option>
                        {floors.map((floor) => (
                          <option key={floor._id} value={floor._id}>
                            {floor.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Room *
                      </label>
                      <select
                        required
                        value={formData.roomId}
                        onChange={(e) => setFormData({ ...formData, roomId: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="">Select Room</option>
                        {filteredRooms.map((room) => (
                          <option key={room._id} value={room._id}>
                            {room.roomNumber} - {room.floorId?.name} ({room.type})
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Check-in Date *
                      </label>
                      <input
                        type="date"
                        required
                        value={formData.checkinDate}
                        onChange={(e) => setFormData({ ...formData, checkinDate: e.target.value })}
                        min={new Date().toISOString().split('T')[0]} // Disable previous dates
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Check-in Time *
                      </label>
                      <input
                        type="time"
                        required
                        value={formData.checkinTime}
                        onChange={(e) => setFormData({ ...formData, checkinTime: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Expected Checkout Date *
                      </label>
                      <input
                        type="date"
                        required
                        value={formData.expectedCheckoutDate}
                        onChange={(e) => setFormData({ ...formData, expectedCheckoutDate: e.target.value })}
                        min={new Date().toISOString().split('T')[0]} // Disable previous dates
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Expected Checkout Time *
                      </label>
                      <input
                        type="time"
                        required
                        value={formData.expectedCheckoutTime}
                        onChange={(e) => setFormData({ ...formData, expectedCheckoutTime: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Room Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={formData.roomAmount || ''}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                            const roomAmount = parseFloat(value) || 0;
                            const paidAmount = parseFloat(formData.paidAmount) || 0;
                            const remainingAmount = Math.max(0, roomAmount - paidAmount);
                            setFormData({ 
                              ...formData, 
                              roomAmount: value,
                              remainingAmount: remainingAmount.toString(),
                              totalAmount: roomAmount.toString()
                            });
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Paid Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={formData.paidAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                            const paidAmount = parseFloat(value) || 0;
                            const roomAmount = parseFloat(formData.roomAmount) || 0;
                            const remainingAmount = Math.max(0, roomAmount - paidAmount);
                            setFormData({ 
                              ...formData, 
                              paidAmount: value,
                              remainingAmount: remainingAmount.toString()
                            });
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Payment Method
                      </label>
                      <select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="cash">Cash</option>
                        <option value="card">Card</option>
                        <option value="upi">UPI</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Remaining Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={formData.remainingAmount || ''}
                        onChange={(e) => setFormData({ ...formData, remainingAmount: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="0.00"
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                {/* Additional Information Section */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <FiFileText className="mr-2 text-purple-600" />
                    Additional Information
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Special Requests
                      </label>
                      <textarea
                        value={formData.specialRequests}
                        onChange={(e) => setFormData({ ...formData, specialRequests: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        rows="3"
                        placeholder="Any special requests from the guest"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Notes
                      </label>
                      <textarea
                        value={formData.notes}
                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        rows="3"
                        placeholder="Additional notes or comments"
                      />
                    </div>
                  </div>
                </div>

                {/* Guest Details Section */}
                <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <FiUser className="mr-2 text-purple-600" />
                    Guest Details
                  </h4>

                  <div className="space-y-6">
                    {formData.persons.map((person, index) => (
                      <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200" data-guest-index={index}>
                        <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-300">
                          <h5 className="text-base font-semibold text-gray-900">Guest {index + 1}</h5>
                          {formData.persons.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removePerson(index)}
                              className="px-3 py-1 bg-red-100 text-red-600 text-sm rounded-lg hover:bg-red-200 transition-colors"
                            >
                              Remove
                            </button>
                          )}
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {/* Personal Information */}
                          <div className="space-y-4">
                            <h6 className="text-sm font-medium text-gray-700 mb-2">Personal Information</h6>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Guest Name *
                              </label>
                              <input
                                type="text"
                                required
                                value={person.name}
                                onChange={(e) => updatePerson(index, 'name', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="Enter full name"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Mobile Number
                              </label>
                              <input
                                type="tel"
                                value={person.mobileNumber}
                                onChange={(e) => updatePerson(index, 'mobileNumber', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="Mobile number"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Email Address
                              </label>
                              <input
                                type="email"
                                value={person.email}
                                onChange={(e) => updatePerson(index, 'email', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="email@example.com"
                              />
                            </div>
                          </div>

                          {/* Identity Information */}
                          <div className="space-y-4">
                            <h6 className="text-sm font-medium text-gray-700 mb-2">Identity Information</h6>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Identity Number
                              </label>
                              <input
                                type="text"
                                value={person.identityNumber}
                                onChange={(e) => updatePerson(index, 'identityNumber', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="Enter identity number"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Age
                              </label>
                              <input
                                type="text"
                                inputMode="numeric"
                                value={person.age}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 1 && parseInt(value) <= 120)) {
                                    updatePerson(index, 'age', value);
                                  }
                                }}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                placeholder="Age"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Gender
                              </label>
                              <select
                                value={person.gender}
                                onChange={(e) => updatePerson(index, 'gender', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                              >
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>

                          {/* Address & Documents */}
                          <div className="space-y-4">
                            <h6 className="text-sm font-medium text-gray-700 mb-2">Address & Documents</h6>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Address
                              </label>
                              <textarea
                                value={person.address}
                                onChange={(e) => updatePerson(index, 'address', e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                rows="3"
                                placeholder="Complete address"
                              />
                            </div>
                            <div>
                              <label className="block text-xs font-medium text-gray-600 mb-1">
                                Identity Card Image
                              </label>
                              <input
                                type="file"
                                accept="image/*"
                                id={`aadharImage${index}`}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm file:mr-2 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                              />
                              <p className="text-xs text-gray-500 mt-1">
                                Upload clear photo of identity card (JPG, PNG, max 5MB) - Optional
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  {/* Add Guest Button at Bottom */}
                  <div className="flex justify-center mt-6">
                    <button
                      type="button"
                      onClick={addPerson}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center"
                    >
                      <FiPlus className="mr-2" />
                      Add Guest
                    </button>
                  </div>
                </div>

                {/* Notes and Special Requests Section */}
                {/* <div className="mb-8">
                  <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                    <FiFileText className="mr-2 text-orange-600" />
                    Notes & Special RequestsTest
                  </h4>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Special Requests
                      </label>
                      <textarea
                        value={formData.specialRequests || ''}
                        onChange={(e) => setFormData({ ...formData, specialRequests: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        rows="3"
                        placeholder="Enter any special requests or requirements..."
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Additional Notes
                      </label>
                      <textarea
                        value={formData.notes || ''}
                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        rows="3"
                        placeholder="Enter any additional notes or comments..."
                      />
                    </div>
                  </div>
                </div> */}

                {/* Form Actions */}
                <div className="flex justify-end space-x-4 sticky bottom-0 bg-white pt-4 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCheckinModal(false);
                      resetForm();
                    }}
                    className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center"
                  >
                    <FiPlus className="mr-2" />
                    Make Booking
                  </button>
                  <button
                    type="button"
                    onClick={handleDirectCheckin}
                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
                  >
                    <FiCheckCircle className="mr-2" />
                    Checked In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Booking Information Modal (for booked rooms) */}
      {showBookingInfoModal && selectedBooking && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-5 mx-auto p-6 border w-full max-w-4xl shadow-2xl rounded-xl bg-white">
            <div className="max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200 sticky top-0 bg-white">
                <h3 className="text-xl font-bold text-gray-900">Booking Information</h3>
                <button
                  onClick={() => {
                    setShowBookingInfoModal(false);
                    setSelectedBooking(null);
                  }}
                  className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <FiX className="text-xl text-gray-500" />
                </button>
              </div>

              {/* Booking Status Badge */}
              <div className="mb-6">
                <span className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium ${
                  selectedBooking.status === 'booked' 
                    ? 'bg-yellow-100 text-yellow-800' 
                    : selectedBooking.status === 'checked_in'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {selectedBooking.status.replace('_', ' ').toUpperCase()}
                </span>
              </div>

              {/* Room Information */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <FiHome className="mr-2 text-blue-600" />
                  Room Details
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <p className="text-sm text-gray-600">Room Number</p>
                    <p className="font-medium text-gray-900">{selectedBooking.roomId?.roomNumber}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Floor</p>
                    <p className="font-medium text-gray-900">{selectedBooking.floorId?.name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Room Type</p>
                    <p className="font-medium text-gray-900">{selectedBooking.roomId?.type}</p>
                  </div>
                </div>
              </div>

              {/* Booking Dates */}
              <div className="bg-blue-50 rounded-lg p-4 mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <FiCalendar className="mr-2 text-blue-600" />
                  Booking Dates
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <p className="text-sm text-gray-600 mb-2">Booking Date</p>
                    <div className="bg-white rounded-lg p-3 border border-green-200">
                      <div className="flex items-center">
                        <FiCalendar className="text-green-600 mr-2" />
                        <span className="font-medium text-gray-900">
                          {new Date(selectedBooking.bookingDate || selectedBooking.createdAt).toLocaleDateString('en-IN', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600 mt-1">
                        <span className="font-medium">Time:</span>
                        <span className="ml-2">
                          {new Date(selectedBooking.bookingDate || selectedBooking.createdAt).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-2">Check-in Details</p>
                    <div className="bg-white rounded-lg p-3 border border-blue-200">
                      <div className="flex items-center mb-2">
                        <FiCalendar className="text-blue-600 mr-2" />
                        <span className="font-medium text-gray-900">
                          {new Date(selectedBooking.checkinDateTime).toLocaleDateString('en-IN', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <span className="font-medium">Time:</span>
                        <span className="ml-2">
                           {new Date(selectedBooking.checkinDateTime).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-2">Expected Checkout Details</p>
                    <div className="bg-white rounded-lg p-3 border border-blue-200">
                      <div className="flex items-center mb-2">
                        <FiCalendar className="text-blue-600 mr-2" />
                        <span className="font-medium text-gray-900">
                          {new Date(selectedBooking.expectedCheckoutDateTime).toLocaleDateString('en-IN', {
                            weekday: 'short',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                        </span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <span className="font-medium">Time:</span>
                        <span className="ml-2">
                          {new Date(selectedBooking.expectedCheckoutDateTime).toLocaleTimeString('en-IN', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guest Information */}
              <div className="bg-green-50 rounded-lg p-4 mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <FiUser className="mr-2 text-green-600" />
                  Guest Details
                </h4>
                <div className="space-y-4">
                  {selectedBooking.persons?.map((person, index) => (
                    <div key={index} className="border-l-4 border-green-400 pl-4">
                      <p className="font-medium text-gray-900">{person.name}</p>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-1">
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Mobile:</span> {person.mobileNumber}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Identity:</span> {person.identityNumber}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Age:</span> {person.age} ({person.gender})
                        </p>
                      </div>
                      
                      {/* Identity Card Image */}
                      {person.identityImage && (
                        <div className="mt-3">
                          <p className="text-xs font-medium text-gray-600 mb-2">Identity Card Image:</p>
                          <div className="inline-block">
                            <img 
                              src={person.identityImage} 
                              alt={`Identity Card - ${person.name}`}
                              className="w-32 h-24 object-cover rounded-lg border border-gray-300 cursor-pointer hover:scale-105 transition-transform"
                              onClick={() => {
                                // Open image in new tab for larger view
                                window.open(person.identityImage, '_blank');
                              }}
                              onError={(e) => {
                                // Handle broken image
                                e.target.style.display = 'none';
                                console.error('Failed to load identity image:', person.identityImage);
                              }}
                            />
                          </div>
                        </div>
                      )}
                      
                      {/* Address */}
                      {person.address && (
                        <div className="mt-2">
                          <p className="text-xs text-gray-600">
                            <span className="font-medium">Address:</span> {person.address}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Notes and Special Requests */}
              {(selectedBooking.specialRequests || selectedBooking.notes) && (
                <div className="bg-orange-50 rounded-lg p-4 mb-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                    <FiFileText className="mr-2 text-orange-600" />
                    Notes & Special Requests
                  </h4>
                  <div className="space-y-3">
                    {selectedBooking.specialRequests && (
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Special Requests:</p>
                        <p className="text-sm text-gray-600 bg-white rounded-lg p-3 border border-orange-200">
                          {selectedBooking.specialRequests}
                        </p>
                      </div>
                    )}
                    {selectedBooking.notes && (
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Additional Notes:</p>
                        <p className="text-sm text-gray-600 bg-white rounded-lg p-3 border border-orange-200">
                          {selectedBooking.notes}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Payment Information */}
              <div className="bg-yellow-50 rounded-lg p-4 mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <span className="mr-2 text-yellow-600">₹</span>
                  Payment Details
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <p className="text-sm text-gray-600">Total Amount</p>
                    <p className="font-medium text-gray-900">₹{selectedBooking.pricing.totalFinalAmount}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Paid Amount</p>
                    <p className="font-medium text-gray-900">₹{selectedBooking.pricing.finalPaidAmount || 0}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Payment Status</p>
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                      selectedBooking.paymentStatus === 'paid' 
                        ? 'bg-green-100 text-green-800'
                        : selectedBooking.paymentStatus === 'partial'
                        ? 'bg-yellow-100 text-yellow-800'
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {selectedBooking.paymentStatus?.toUpperCase()}
                    </span>
                  </div>
                </div>
              </div>

              {/* Actions */}
              <div className="flex justify-end space-x-3 sticky bottom-0 bg-white pt-4 border-t border-gray-200">
                {(selectedBooking.status === 'booked') && (
                  <>
                    <button
                      onClick={() => {
                        handlePerformCheckin(selectedBooking)
                        setViewMode("floors")
                      }}
                      className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
                    >
                      <FiCheckCircle className="mr-2" />
                      Check-in Guest
                    </button>
                    <button
                      onClick={() => {
                        // Open edit modal with selected booking
                        setShowEditModal(true);
                      }}
                      className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center"
                    >
                      <FiEdit2 className="mr-2" />
                      Edit Booking
                    </button>
                    <button
                      onClick={() => {
                        setCancelFormData({
                          remark: '',
                          refundableAmount: 0
                        });
                        setShowCancelModal(true);
                      }}
                      className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center"
                    >
                      <FiXCircle className="mr-2" />
                      Cancel Booking
                    </button>
                  </>
                )}
                {selectedBooking.status === 'checked_in' && (
                  <>
                    <button
                      onClick={() => {
                        // Open edit modal with selected booking
                        setShowEditModal(true);
                      }}
                      className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center"
                    >
                      <FiEdit2 className="mr-2" />
                      Edit Booking
                    </button>
                    <button
                      onClick={() => initializeCheckoutModal(selectedBooking)}
                      className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors flex items-center"
                    >
                      <FiLogOut className="mr-2" />
                      Check-out Guest
                    </button>
                    <button
                      onClick={() => {
                        setCancelFormData({
                          remark: '',
                          refundableAmount: 0
                        });
                        setShowCancelModal(true);
                      }}
                      className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center"
                    >
                      <FiXCircle className="mr-2" />
                      Cancel Booking
                    </button>
                  </>
                )}
                <button
                  onClick={() => {
                    setShowBookingInfoModal(false);
                    setSelectedBooking(null);
                  }}
                  className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cancellation Confirmation Modal */}
      {showCancelModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-6 border w-full max-w-md shadow-2xl rounded-xl bg-white">
            <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">Cancel Booking</h3>
              <button
                onClick={() => setShowCancelModal(false)}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FiX className="text-xl text-gray-500" />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cancellation Remark <span className="text-red-500">*</span>
                </label>
                <textarea
                  required
                  value={cancelFormData.remark}
                  onChange={(e) => setCancelFormData({ ...cancelFormData, remark: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  rows="3"
                  placeholder="Enter reason for cancellation..."
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Refundable Amount (₹)
                </label>
                <input
                  type="text"
                  inputMode="decimal"
                  value={cancelFormData.refundableAmount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                      setCancelFormData({ ...cancelFormData, refundableAmount: parseFloat(value) || 0 });
                    }
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  placeholder="0.00"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Amount to be refunded to the customer
                </p>
              </div>

              {selectedBooking && (
                <div className="bg-gray-50 rounded-lg p-3">
                  <p className="text-sm text-gray-600">
                    <span className="font-medium">Total Paid:</span> ₹{selectedBooking.pricing.paidAmount || 0}
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200">
              <button
                onClick={() => setShowCancelModal(false)}
                className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Back
              </button>
              <button
                onClick={() => {
                  if (!cancelFormData.remark.trim()) {
                    alert('Please enter a cancellation remark');
                    return;
                  }
                  handleCancelBooking(selectedBooking, cancelFormData);
                  setShowCancelModal(false);
                  setViewMode("floors")
                }}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center"
              >
                <FiXCircle className="mr-2" />
                Confirm Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Checkout Modal */}
      {showCheckoutModal && selectedBooking && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto border w-[500px] shadow-2xl rounded-xl bg-white flex flex-col max-h-[80vh]">
            {/* Header */}
            <div className="flex items-center justify-between p-6 pb-4 border-b border-gray-200 flex-shrink-0">
              <h3 className="text-xl font-bold text-gray-900">Guest Check-out</h3>
              <button
                onClick={() => {
                  setShowCheckoutModal(false);
                  setSelectedBooking(null);
                }}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FiX className="text-xl text-gray-500" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-6">
              {/* Guest Information */}
              <div className="mb-6">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-1">
                        {selectedBooking.persons?.[0]?.name || 'Guest'}
                      </h4>
                      <div className="space-y-1">
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Room:</span> {selectedBooking.roomId?.roomNumber}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium">Check-in ID:</span> {selectedBooking.checkinId}
                        </p>
                      </div>
                    </div>
                    <div className="text-center">
                      <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                        <FiUser className="text-2xl text-blue-600" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Payment Details with GST */}
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <FiHome className="mr-2 text-green-600" />
                  Payment Breakdown
                </h4>
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">Base Amount:</span>
                      <span className="text-sm font-bold text-gray-900">₹{calculatedBase.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">GST ({dynamicGst}%):</span>
                      <span className="text-sm font-bold text-blue-600">+ ₹{calculatedGstAmount.toFixed(2)}</span>
                    </div>
                   
                    <div className="border-t pt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-base font-semibold text-gray-800">
                          Total Amount:
                        </span>

                        <div className="text-right">
                          {/* Original Price */}
                          {discountAmount > 0 && (
                            <div className="text-sm text-gray-500 line-through">
                              ₹{paymentAmountByApi?.totalRoomAmount?.toFixed(2)}
                            </div>
                          )}

                          {/* Discount Amount (Red) */}
                          {discountAmount > 0 && (
                            <div className="text-sm font-medium text-red-500">
                              - ₹{discountAmount.toFixed(2)}
                            </div>
                          )}

                          {/* Final Price */}
                          <div className="text-base font-bold text-green-600">
                            = ₹{calculatedTotal.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                     {dynamicOtherAmount > 0 && (
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Other Amount:</span>
                        <span className="text-sm font-bold text-purple-600">+ ₹{dynamicOtherAmount}</span>
                      </div>
                    )}
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">Paid Amount:</span>
                      <span className="text-sm font-bold text-green-600">- ₹{dynamicPaidAmount}</span>
                    </div>
                    {
                      tipAmount > 0 && 
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-600">Tip Amount:</span>
                        <span className="text-sm font-bold text-green-600">+ ₹{tipAmount}</span>
                      </div>
                    }
                    <div className="border-t pt-3">
                      <div className="flex justify-between items-center">
                        <span className="text-base font-semibold text-gray-800">Due Balance:</span>
                        <span className={`text-base font-bold ${
                          calculatedDue > 0
                            ? 'text-red-600'
                            : 'text-green-600'
                        }`}>
                          = ₹{calculatedDue.toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center pt-2">
                      <span className="text-sm text-gray-600">Payment Status:</span>
                      <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${
                        calculatedDue > 0
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-green-100 text-green-800'
                      }`}>
                        {calculatedDue > 0 ? 'PARTIAL' : 'PAID'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
                
              {/* Final Payment Collection */}
              <div className="mb-6">
                <h4 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                  <FiEdit2 className="mr-2 text-orange-600" />
                  Final Payment Details
                </h4>
                <form onSubmit={(e) => e.preventDefault()} className="bg-orange-50 rounded-lg p-4 border border-orange-200">
                  <div className="grid grid-cols-1 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        GST Percentage
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          inputMode="decimal"
                          value={dynamicGst}
                          placeholder="18"
                          className="w-full px-3 py-2 pr-8 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                          onChange={(e) => setDynamicGst(e.target.value)}
                        />
                        <span className="absolute right-3 top-2.5 text-gray-500 text-sm">%</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Final Room Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={dynamicFinalAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                            setDynamicFinalAmount(parseFloat(value) || 0);
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="0.00"
                      />
                    </div>
                    {/* <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Other Amount (Food, etc.)
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={dynamicOtherAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                            setDynamicOtherAmount(parseFloat(value) || 0);
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="0.00"
                      />
                    </div> */}
                    {/* <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Other Amount Remark
                      </label>
                      <textarea
                        value={dynamicOtherAmountRemark}
                        onChange={(e) => setDynamicOtherAmountRemark(e.target.value)}
                        placeholder="Enter details for other charges (food, laundry, etc.)"
                        rows="2"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      />
                    </div> */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Final Pending Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        disabled
                        value={finalPendingAmount}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm bg-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                        placeholder="0.00"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Settled Amount
                      </label>
                      <input
                        type="text"
                        inputMode="decimal"
                        value={settledAmount}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                            setSettledAmount(parseFloat(value) || 0);
                          }
                        }}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                        placeholder="0.00"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Amount actually settled (can be different from pending amount)
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Customer GST Number
                      </label>
                      <input
                        type="text"
                        value={customerGstNumber}
                        onChange={(e) => setCustomerGstNumber(e.target.value.toUpperCase())}
                        placeholder="Enter Customer GST Number"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Enter customer GST number for billing purposes
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Tip & Discount Amounts
                      </label>
                      <div className="w-full px-3 py-1.5 border border-gray-200 rounded text-sm bg-gray-50 text-gray-700">
                        <span className="font-semibold text-green-700">Tip: {tipAmount > 0 ? `+${tipAmount.toFixed(2)}` : '0.00'}</span>
                        <span className="mx-4 text-gray-400">|</span>
                        <span className="font-semibold text-orange-700">Discount: {discountAmount > 0 ? `-${discountAmount.toFixed(2)}` : '0.00'}</span>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Payment Method
                      </label>
                      <select
                        value={paymentMethod}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                      >
                        <option value="cash">Cash</option>
                        <option value="upi">UPI</option>
                        <option value="card">Card</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end space-x-3 p-6 pt-4 border-t border-gray-200 bg-white flex-shrink-0">
              <button
                onClick={() => {
                  setShowCheckoutModal(false);
                  setSelectedBooking(null);
                }}
                className="px-6 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleCheckoutSubmit}
                className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
              >
                <FiCheckCircle className="mr-2" />
                Check-out Guest
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Booking Modal */}
      {showEditModal && (
        <EditBookingModal
          showEditModal={showEditModal}
          setShowEditModal={setShowEditModal}
          bookingId={selectedBooking?._id}
        />
      )}
    </>
  );
};

export default BookingModals;
